import { ready } from "./utils.js";
import { dropdown } from "./dropdown.js";
import { featuredSlider, insightsSlider, cardSlider } from "./sliders.js";
import { superHeroSelect } from "./superhero.js";
import { locationSearch } from "./locationsearch.js";
import { findaDoctor } from "./findadoctor.js";

ready(() => {
  dropdown();
  featuredSlider();
  insightsSlider();
  cardSlider();
  superHeroSelect();
  locationSearch();
  findaDoctor();
});
